{
  "id": "pruefung-sbf",
  "title": "Bewertungsschlüssel der theoretischen Prüfung zum Sportbootführerschein (ELWIS, WSV)",
  "url": "https://www.elwis.de/DE/Sportschifffahrt/Sportbootfuehrerscheine/Bewertungsschluessel/Bewertungsschluessel-node.html",
  "retrieved": "2026-09-19",
  "license": "Amtliche Bekanntmachung der Wasserstraßen- und Schifffahrtsverwaltung des Bundes",
  "stand": "2022-10-31",
  "variants": [
    {
      "title": "Binnen mit Antriebsmaschine oder Binnen mit Antriebsmaschine hat SBF Binnen/Segel nach dem 30. April 2012 erworben",
      "area": "binnen",
      "total": 30,
      "minutes": 45,
      "parts": [
        {
          "name": "Basis",
          "questions": 7,
          "minPoints": 5
        },
        {
          "name": "Spez. Binnen",
          "questions": 23,
          "minPoints": 18
        }
      ]
    },
    {
      "title": "Binnen mit Antriebsmaschine hat SBF-See",
      "area": "binnen",
      "total": 23,
      "minutes": 35,
      "parts": [
        {
          "name": "Spez. Binnen",
          "questions": 23,
          "minPoints": 18
        }
      ]
    },
    {
      "title": "Binnen mit Antriebsmaschine und Segeln",
      "area": "binnen",
      "total": 37,
      "minutes": 60,
      "parts": [
        {
          "name": "Basis",
          "questions": 7,
          "minPoints": 5
        },
        {
          "name": "Spez. Binnen",
          "questions": 23,
          "minPoints": 18
        },
        {
          "name": "Segeln",
          "questions": 7,
          "minPoints": 5
        }
      ]
    },
    {
      "title": "Binnen Segeln",
      "area": "binnen",
      "total": 25,
      "minutes": 35,
      "parts": [
        {
          "name": "Basis",
          "questions": 4,
          "sharedMinPoints": 20
        },
        {
          "name": "Spez. Binnen",
          "questions": 14,
          "sharedMinPoints": 20
        },
        {
          "name": "Segeln",
          "questions": 7,
          "sharedMinPoints": 20
        }
      ]
    },
    {
      "title": "Segeln hat SBF-See",
      "area": "binnen",
      "total": 21,
      "minutes": 35,
      "parts": [
        {
          "name": "Spez. Binnen",
          "questions": 14,
          "sharedMinPoints": 17
        },
        {
          "name": "Segeln",
          "questions": 7,
          "sharedMinPoints": 17
        }
      ]
    },
    {
      "title": "Segeln hat SBF-Binnen mit Antriebsmaschine",
      "area": "binnen",
      "total": 7,
      "minutes": 15,
      "parts": [
        {
          "name": "Segeln",
          "questions": 7,
          "minPoints": 5
        }
      ]
    },
    {
      "title": "Binnen mit Antriebsmaschine, hat SBF-Binnen/Segel vor dem 01. Mai 2012 erworben",
      "area": "binnen",
      "total": 7,
      "minutes": 15,
      "parts": [
        {
          "name": "Basis",
          "questions": 7,
          "minPoints": 5
        }
      ]
    },
    {
      "title": "SBF-See",
      "area": "see",
      "total": 39,
      "minutes": 60,
      "parts": [
        {
          "name": "Basis",
          "questions": 7,
          "minPoints": 5
        },
        {
          "name": "Spez. See",
          "questions": 23,
          "minPoints": 18
        },
        {
          "name": "Navigation",
          "questions": 9,
          "minPoints": 7
        }
      ]
    },
    {
      "title": "SBF-See hat SBF-Binnen mit Antriebsmaschine",
      "area": "see",
      "total": 32,
      "minutes": 50,
      "parts": [
        {
          "name": "Spez. See",
          "questions": 23,
          "minPoints": 18
        },
        {
          "name": "Navigation",
          "questions": 9,
          "minPoints": 7
        }
      ]
    }
  ]
}
